export const firstClassTypes = ["1a", "1b", "2"];
export const secondClassTypes = ["2"];
export const thirdClassTypes = ["3a", "3b"];
export const fourthClassTypes = ["1_1a", "1_1b"];
export const fifthClassTypes = ["2_2"];
export const sixthClassTypes = ["3_3a", "3_3b"];
